export const DEFAULT_RANGE_DAYS = 7

export const RUN_LABEL_PRESETS = [
  { label: 'All', value: '' },
  { label: 'live', value: 'live' },
  { label: 'replay', value: 'replay' },
] as const

export const RUN_LABEL_DEBOUNCE_MS = 400

export const TABLE_COLUMNS_COUNT = 12

/** Verdicts with a resolved final case; `in_tie` counts as not correct. */
export const SCORED_VERDICTS = new Set(['correct', 'wrong', 'in_tie'])
